angular.module('impactx.user').controller('DelegationCtrl', ['$scope', DelegationCtrl]);

function DelegationCtrl($scope)
{
    this.addDelegationStep = function() {
        var tmpDelegates = {};
        angular.copy($scope.delegations[0].delegates, tmpDelegates);
        tmpDelegates.selected = [];

        var tmpReasons = {};
        angular.copy($scope.delegations[0].reasons, tmpReasons);

        var emptyDelegation = {
            id: 0,
            activated: false,
            reasons: tmpReasons,
            delegates: tmpDelegates,
            startDate: {label: $scope.delegations[0].startDate.label, dateValue: null, value: ""},
            endDate: {label: $scope.delegations[0].endDate.label, dateValue: null, value: ""},
            silentDelegation: {label: $scope.delegations[0].silentDelegation.label},
            active: {label: $scope.delegations[0].active.label}
        };

        if($scope.delegations[0].lowValueApproval)
        {
            emptyDelegation.lowValueApproval = {label: $scope.delegations[0].lowValueApproval.label};
            emptyDelegation.lowValue = {label: $scope.delegations[0].lowValue.label};
            emptyDelegation.currency = {label: $scope.delegations[0].currency.label,
                entries: $scope.delegations[0].currency.entries,
                selected: $scope.delegations[0].currency.selected};
        }
        $scope.delegations.push(emptyDelegation)
    };

    this.deleteDelegationStep = function(index) {
        $scope.delegations.splice(index, 1);
    };
}